import React from 'react';

import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import AutoComplete from "@mui/material/Autocomplete";

export default function InvoiceNumberAutocomplete ({handleChange, searchFct, error, helperText, currentValue, label}) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const response = await searchFct('');

      if (active) {
        if (response.data) {
          setOptions(response.data);
        } else {
          setOptions([]);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
      <AutoComplete
          freeSolo
          autoSelect
          style={{ marginTop: 20 }}
          id="autocomplete"
          fullWidth
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          getOptionSelected={(option, value) => option.id === value.id}
          onInputChange={(e, data) => handleChange(data)}
          value={currentValue === '' ? null : currentValue}
          getOptionLabel={(option) => option + ''}
          options={options}
          loading={loading}
          renderInput={(params) => (
              <TextField
                  {...params}
                  label={label}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <React.Fragment>
                          {loading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                    ),
                  }}
                  error={error}
                  helperText={helperText}
              />
          )}
      />
  );
}